import axios from '../../axios';

export const csrfTokenCall = () => axios.post('/api/csrf-token');
